import { createContext, useState } from 'react';

interface IDimension {
    height: number;
    width: number;
}

interface IScatterPlotContext {
    currentTooltip?: any;
    setCurrentToolTip: (data: any) => void;
    dimension: IDimension;
    setDimension: (dimension: IDimension) => void;
}

const defaultContext: IScatterPlotContext = {
    currentTooltip: undefined,
    setCurrentToolTip: () => {},
    dimension: { height: 0, width: 0 },
    setDimension: () => {}
};

export const ScatterPlotContext = createContext(defaultContext);

export const ScatterPlotContextProvider = ({ children }: { children: any }) => {
    const [currentTooltip, setCurrentToolTip] = useState();
    const [dimension, setDimension] = useState<IDimension>({ height: 0, width: 0 });

    return (
        <ScatterPlotContext.Provider
            value={{
                currentTooltip,
                setCurrentToolTip,
                dimension,
                setDimension
            }}
        >
            {children}
        </ScatterPlotContext.Provider>
    );
};
